export default __webpack_public_path__ + "static/media/EstacoesIconBlue.f9cb365c.svg";